import { render } from "./HeroiconsOutlineUserGroup.vue?vue&type=template&id=63de9e3a"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineUserGroup.vue"]])

export default __exports__